import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CurrencyPipe, JsonPipe, NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IChart } from '@bp-core/src/lib/models/portal/chart.model';
import { fuseAnimations } from '@fuse/animations';
import { NoDataChartComponent } from 'bp/modules/goal/pages/goal-detail/components/summary-money-evolution-chart-card/no-data-chart/no-data-chart.component';
import { BpActivitiesGroupFilter } from 'bp/shared/models/activities-filters-info';
import dayjs from 'dayjs';
import { CurrencyModel } from 'projects/bp-core/src/lib/proto/common-message.pb';
import { Subject, takeUntil } from 'rxjs';
import { BpCoreModule } from '../../../../../../bp-core/src/lib/bp-core.module';
import { GPBChartSingleComponent } from './components/g-p-b-chart-single/g-p-b-chart-single.component';
import { GPBChartComponent } from './components/g-p-b-chart/g-p-b-chart.component';
import { GPBTableComponent } from './components/g-p-b-table/g-p-b-table.component';

@Component({
  selector: 'app-g-p-balance',
  templateUrl: './g-p-balance.component.html',
  styleUrls: ['./g-p-balance.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: fuseAnimations,
  standalone: true,
  imports: [
    BpCoreModule,
    GPBChartComponent,
    GPBChartSingleComponent,
    GPBTableComponent,
    NgClass,
    CurrencyPipe,
    MatIconModule,
    MatTooltipModule,
    NoDataChartComponent,
    MatButtonToggleModule,
    FormsModule,
    ReactiveFormsModule,
    JsonPipe,
  ],
})
export class GPBalanceComponent implements OnInit, OnChanges, OnDestroy {
  constructor(private breakpointObserver: BreakpointObserver) {}

  @Input() isGeneralBalance: boolean = false;
  @Input()
  groupFilterInfo: BpActivitiesGroupFilter | undefined = undefined;

  @Input() balance: IChart;
  @Input() balanceSingle: IChart;
  @Input() irrAccumulated: string;
  @Input() irrAccumulatedUSD: string;

  @Input() isLoading = true;
  @Input() hasAllFinancialInstitutions: boolean | undefined;

  @Input() currency: CurrencyModel | undefined;
  @Input() balanceTotalAmount: number;

  @Input() deposits: number;
  @Input() totalCurrentCapital: number | undefined;
  @Input() dateFinalBalance: Date | undefined;
  @Input() withdrawals: number;
  @Input() balanceTotalDate: Date;
  @Input() singleChart = false;
  @Input() balanceInitDate: Date | null;
  @Input() balanceInitAmount = 0;
  @Input() netDeposit = 0;
  @Input() fixedFromDate: string;
  @Input() fixedToDate: string;
  @Input() showDates: boolean;
  @Input() variation: number;

  @Output() chartSelectedOptionChangeEvent = new EventEmitter<string>();

  private _unsubscribe$ = new Subject<void>();
  showDetailTable: boolean = false;
  balanceChartontrol = new FormControl<string>('all');

  wasTheGoalCreatedThePastYear: boolean;
  wasTheGoalCreatedThePastPastYear: boolean;
  thisYear: number;
  pastYear: number;
  pastPastYear: number;
  goalYears: number;
  isMobile: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    //  if (changes.chartSelectedOption?.currentValue) {
    //    this.balanceChartontrol.setValue(this.chartSelectedOption);
    //  }
  }
  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  ngOnInit() {
    this.breakpointObserver
      .observe([Breakpoints.Small, Breakpoints.XSmall])
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe({
        next: result => {
          this.isMobile = result.matches;
        },
      });

    this.balanceChartontrol.valueChanges.subscribe({
      next: value => {
        console.log('value', value);
        this.chartSelectedOptionChangeEvent.emit(value ? value : 'all');
      },
    });

    // Get this year
    this.thisYear = dayjs().year();

    // Get past year
    this.pastYear = dayjs().subtract(1, 'year').year();

    // Get past past year
    this.pastPastYear = dayjs().subtract(2, 'year').year();

    this.goalYears = dayjs().diff(dayjs(this.groupFilterInfo?.timePeriod?.initialDate), 'year');

    this.wasTheGoalCreatedThePastYear =
      dayjs(this.groupFilterInfo?.timePeriod?.initialDate).year() ===
        dayjs().subtract(1, 'year').year() ||
      dayjs(this.groupFilterInfo?.timePeriod?.initialDate).year() <
        dayjs().subtract(1, 'year').year();

    this.wasTheGoalCreatedThePastPastYear =
      dayjs(this.groupFilterInfo?.timePeriod?.initialDate).year() ===
        dayjs().subtract(2, 'year').year() ||
      dayjs(this.groupFilterInfo?.timePeriod?.initialDate).year() <
        dayjs().subtract(2, 'year').year();

    //this.balanceChartontrol.setValue(this.groupFilterInfo?.timePeriod?.value ?? 'all');
  }

  showDetailTableToggle() {
    this.showDetailTable = !this.showDetailTable;
  }
}
